export const environment = {
    hmr: false,
    production: true,
    version: '3.5.4.268',
};
